export default __webpack_public_path__ + "static/media/capacidad.358c0ee3.svg";